module.exports = __webpack_public_path__ + "media/message 8.0b4fde21.mp3";